import React from 'react';
import { cn } from '@/utils';

export default function InlineSvg({
  slug,
  className,
}: {
  slug: string;
  className?: string;
}) {
  const logos = import.meta.glob('../../../**/*.svg', {
    eager: true,
    as: 'raw',
  });

  // match the logo to the slug
  const svgKey = Object.keys(logos).find(key => key.includes(slug));
  let logo = '';
  if (svgKey) {
    logo = logos[svgKey];
  }

  return (
    <>
      {svgKey && (
        <span
          dangerouslySetInnerHTML={{ __html: logo }}
          className={cn(
            'inline-block [&_svg]:h-full [&_svg]:w-full [&_svg]:fill-current',
            className,
          )}
        ></span>
      )}
      {/* If the logo is not found display an html comment  */}
      {!svgKey && (
        <div
          dangerouslySetInnerHTML={{
            __html: `<!-- svg ${slug} does not exists -->`,
          }}
        />
      )}
    </>
  );
}
